/*
 * @Descripttion: 回收订单列配置
 * @version:
 * @Author: Raoxf
 * @Date: 2025-11-06
 */
const STATUS = {
  pending: "已预约",
  assessed: "回收中",
  completed: "已完成",
  applyreturn: "申请退回",
  rejected: "已退回",
};

const TYPE = {
  0: "手机",
  1: "衣物",
};

export default (Vue) => {
  return [
    {
      title: "订单ID",
      key: "id",
      minWidth: 100,
      align: "center",
    },
    {
      title: "用户姓名",
      key: "userName",
      minWidth: 120,
      align: "center",
    },
    {
      title: "预约时间",
      key: "appointmentTime",
      minWidth: 180,
      align: "center",
    },
    {
      title: "回收类型",
      key: "type",
      minWidth: 100,
      align: "center",
      render: (h, { row }) => {
        const text = TYPE[row.type] || "-";
        return h("span", {}, text);
      },
    },
    {
      title: "回收状态",
      key: "status",
      minWidth: 120,
      align: "center",
      render: (h, { row }) => {
        const text = STATUS[row.status] || row.status;
        return h("span", {}, text);
      },
    },
    {
      title: "联系电话",
      key: "userPhone",
      minWidth: 130,
      align: "center",
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      align: "center",
      width: 200,
      render: (h, { row }) => {
        const buttons = [];

        // 填写预估价格按钮，状态为 pending 时显示
        if (row.status === "pending") {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#3091FF",
                  marginRight: "8px",
                },
                on: {
                  click: () => {
                    Vue.currentRow = row;
                    Vue.currentStatus = "pending";
                    Vue.updateForm = {
                      estimatedPrice: "",
                      actualPrice: "",
                      realWeight: "",
                      trackingNum: "",
                    };
                    if (Vue.$refs.updateForm) {
                      Vue.$refs.updateForm.resetFields();
                    }
                    Vue.showUpdateDialog = true;
                  },
                },
              },
              "填写预估价格"
            )
          );
        }

        // 填写实际价格按钮，状态为 assessed 且没有实际价格时显示
        if (row.status === "assessed" && !row.actualPrice) {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#3091FF",
                  marginRight: "8px",
                },
                on: {
                  click: () => {
                    Vue.currentRow = row;
                    Vue.currentStatus = "assessed";
                    Vue.updateForm = {
                      estimatedPrice: "",
                      actualPrice: "",
                      realWeight: "",
                      trackingNum: "",
                    };
                    if (Vue.$refs.updateForm) {
                      Vue.$refs.updateForm.resetFields();
                    }
                    Vue.showUpdateDialog = true;
                  },
                },
              },
              "填写实际价格"
            )
          );
        }

        // 退货按钮，状态为 applyreturn 且没有 trackingReturnNum 时显示
        if (row.status === "applyreturn") {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#3091FF",
                  marginRight: "8px",
                },
                on: {
                  click: () => {
                    Vue.currentRow = row;
                    Vue.showReturnDialog = true;
                  },
                },
              },
              "退货"
            )
          );
        }

        // 详情按钮
        buttons.push(
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  Vue.$router.push({
                    path: "/recycledetail",
                    query: { id: row.id },
                  });
                },
              },
            },
            "详情"
          )
        );

        return h("div", buttons);
      },
    },
  ];
};
